<script>
    import {
        Card,
        CardBody
    } from 'sveltestrap';
    import {colors, calculate, calcBurnRate} from "./slo";
    import {afterUpdate} from "svelte";

    export let slo;
    export let windows;

    let rulesBySeverity = {}

    function generateRules() {
        let x = (100 - $slo).toFixed(3)
        rulesBySeverity = {}
        console.log($windows)
        $windows.forEach((w, idx) => {
            const severity = w.alert.toLowerCase()
            if (!(severity in rulesBySeverity)) {
                rulesBySeverity[severity] = {
                    conditions: [],
                }
            }

            const burnRate = calcBurnRate(w.time_window, w.error_budget_burned_percent)

            rulesBySeverity[severity].conditions.push({
                'expr': 'job:errors_per_request:percent1h{job="myjob"} > ' + burnRate + '*'+x,
                'color': colors[idx],
            })
            rulesBySeverity[severity].severity = severity
        });
        console.log(rulesBySeverity)
    }

    generateRules();

    afterUpdate(() => {
        generateRules();

    })
    // let rules = [
    //     {
    //         language=TEXT
    // code: 'expr: (\n        job:slo_errors_per_request:ratio_rate1h{job="myjob"} > (14.4*0.001)\n      or\n        job:slo_errors_per_request:ratio_rate6h{job="myjob"} > (6*0.001)\n      )\nseverity: page'
    // }
    // ]
</script>

<div>
    <Card style="border: none" body color="dark">
        <CardBody>
            <code style="color: #aaa">
                {#each Object.values(rulesBySeverity) as rule}
                    - name: slo_alert_{rule.severity}<br/>
                    &nbsp;&nbsp;expr: {#if rule.conditions.length > 1}|<br/>{/if}
                    {#each rule.conditions as condition, idx}
                        {#if idx !== 0}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;or<br/>{/if}

                        {#if rule.conditions.length > 1}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;({/if}<strong style="color: {condition.color}">{condition.expr}</strong>{#if rule.conditions.length > 1}){/if}
                        <br/>

                    {/each}
                    &nbsp;&nbsp;labels:<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;severity: {rule.severity}<br/>
                    <br/>

                {/each}
            </code>
        </CardBody>
    </Card>
</div>